const PositionTypeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
        fill="#85C553"
      />
      <path
        d="M32 15.9998H30.3333V13.9998C30.3333 12.7198 29.28 11.6665 28 11.6665H20C18.7067 11.6665 17.6667 12.7198 17.6667 13.9998V15.9998H16C13.3333 15.9998 12 17.3332 12 19.9998V21.2798C12 22.5198 12.7333 23.6132 13.88 24.0532C15.72 24.7866 17.6267 25.3466 19.5333 25.7466C19.68 25.7732 19.8133 25.6665 19.8933 25.5465C20.8533 24.1066 22.4 23.2399 24 23.2399C25.6133 23.2399 27.1467 24.1066 28.12 25.5465C28.2 25.6665 28.3333 25.7732 28.48 25.7466C30.3867 25.3466 32.28 24.7866 34.12 24.0666C35.2667 23.6132 36 22.5198 36 21.2798V19.9998C36 17.3332 34.6667 15.9998 32 15.9998ZM19.6667 15.9998V13.9998C19.6667 13.8132 19.8133 13.6665 20 13.6665H28C28.1867 13.6665 28.3333 13.8132 28.3333 13.9998V15.9998H19.6667ZM28.88 27.7065C28.7333 27.7332 28.5733 27.7466 28.4267 27.7466C27.6533 27.7466 26.92 27.3465 26.4533 26.6532C25.8667 25.7732 24.9467 25.2399 24 25.2399C23.0667 25.2399 22.1467 25.7732 21.56 26.6532C21 27.4798 20.0533 27.8932 19.1333 27.7065C17.1067 27.2932 15.0933 26.6931 13.1467 25.9198C12.7333 25.7598 12.3467 25.5464 12 25.2664V31.9998C12 34.6665 13.3333 35.9998 16 35.9998H32C34.6667 35.9998 36 34.6665 36 31.9998V25.2798C35.6533 25.5465 35.2667 25.7598 34.8533 25.9198C32.9067 26.6931 30.8933 27.2932 28.88 27.7065ZM24.0027 29.3332C23.268 29.3332 22.6667 28.7358 22.6667 27.9998C22.6667 27.2638 23.2573 26.6665 23.992 26.6665H24.0027C24.7373 26.6665 25.3333 27.2638 25.3333 27.9998C25.3333 28.7358 24.7373 29.3332 24.0027 29.3332Z"
        fill="#F3F9EE"
      />
    </svg>
  );
};

export default PositionTypeIcon;
